import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

// Phase 9 — first-party pageview beacon. GDPR posture:
// - Fires ONLY when the user chose "Accept all" in the cookie banner
//   (localStorage.cookie_consent === "accepted"); "Essential only" = no beacon.
// - Sends path + a random per-browser-session hash. No user id, no IP stored.
function getSessionHash() {
  let h = sessionStorage.getItem("pv_session");
  if (!h) {
    h = Array.from(crypto.getRandomValues(new Uint8Array(12)))
      .map((b) => b.toString(16).padStart(2, "0")).join("");
    sessionStorage.setItem("pv_session", h);
  }
  return h;
}

export default function PageviewBeacon() {
  const { pathname } = useLocation();
  const last = useRef("");

  useEffect(() => {
    try {
      if (localStorage.getItem("cookie_consent") !== "accepted") return;
      if (last.current === pathname) return;
      last.current = pathname;
      api.sendPageview(pathname, getSessionHash()).catch(() => {});
    } catch { /* storage blocked — never track, never break */ }
  }, [pathname]);

  return null;
}
